import axios from 'axios';
import { POST_CABLE_OPTIC_CANTON_API_URL, POST_WELL_CANTON_API_URL, POST_PILLAR_CANTON_API_URL,
  POST_COUPLING_CANTON_API_URL, POST_FOB_CANTON_API_URL, POST_EDITING_CABLE_OPTIC_CANTON_API_URL,
  POST_END_HIGHWAY_LINE_API_URL, 
  POST_EDITING_CABLE_OPTIC_HIGHWAY_API_URL,
  POST_PROBLEM_CABLE_LOCATION_API_URL} from '../OpticApiConfig';
import { CONST_CANTON, CONST_HIGHWAY } from '../Constants/ConstantsOptics';  

// запись LineOpticCanton
export const WriteLineOpticCanton = async (coordinatesCableLine, commentTextAreaRefCable,selectedContractor, cableOpticId, cableTypeId,
    isLineDrawing, showSnackbar, setCoordinatesCableLine, setCommentCable, setSelectedCable,setSelectedTypeCable,
    setSelectedContractor,handleClickCantonEdit, setLengthCable,lengthCable,setSelectedRankCable,
    selectedRankCable, user, cantonCablaByIdRefresh) => {  



    const token = localStorage.getItem('token');
    const comment = commentTextAreaRefCable.current.value;
    
    if (coordinatesCableLine.length === 0 || comment.trim() === '' || selectedContractor === null  ) {
      showSnackbar('Кабель! Не все поля заполнены!', 'snackbarWarning');
    return;
  } else if(isLineDrawing == true){
      showSnackbar('Кабель! Завершите действие!', 'snackbarWarning');
  } else if(!token){
      showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
  } else{
    
      try {
          let city = 'null';
          let canton = 'null';
          let area = 0;
          let flag = '';

         

          const coordinatesArray = coordinatesCableLine.map(coord => {
            if (coord.flagTerritory === 'city') {
              flag = 'city'
              city = coord.polygonInfo;
            } else if (coord.flagTerritory === 'canton') {
              flag = 'canton'
              canton = coord.polygonInfo;
            } else if (coord.flagTerritory === 'area') {
               flag = 'canton'
               area = coord.polygonInfo;
            }

            if (coord.latLng) {
              const result = {
                  Latitude: coord.latLng.lat,
                  Longitude: coord.latLng.lng,
                  City: city,
                  Canton: canton,
                  Area: area,
                  Flag: flag,
                  LengthSegment: coord.lengthSegment,
                  ConnectionEntrance: coord.entrance,
                  ConnectionHid: coord.hid
              };
      
              city = 'null';
              canton = 'null';
              area = 0;
              flag = '';
      
              return result;
          }
      
          city = 'null';
          canton = 'null';
          area = 0;
          flag = '';

          return null;
      }).filter(coord => coord !== null);

       

         const response =  await axios.post(POST_CABLE_OPTIC_CANTON_API_URL, {
              Coordinates: coordinatesArray,
              CableId: cableOpticId,
              CableTypeId: cableTypeId,
              Description: comment,
              ContractorId: selectedContractor,
              // Canton: selectCantonCable,
              // Region: selectedRegionCable,
              // Area: selectedAreaCable,
              AuthorId: user,
              RankCableId: selectedRankCable,
              Status: 1,
              Order: 0,
              LengthCable: lengthCable                 
          }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

         const newLineId = response.data;
            
        setCoordinatesCableLine([]);
        setCommentCable("");     
        setSelectedCable([]);
        setSelectedTypeCable(null);
        //setSelectedContractor(null);
        setSelectedRankCable(null);
        setLengthCable(0);
       // handleClickCantonEdit();
        cantonCablaByIdRefresh(newLineId);

        showSnackbar('Кабель! Данные сохранены успешно', 'snackbarOk');
      } catch (error) {
          console.error("Ошибка при сохранении данных:", error);
      } 
}
}

// ПЕРЕЗАПИСЬ LineOpticCanton \ LineOpticHighway
export const EditingLineOptic= async (lineId, lineEditing,lengthCableEditing, markerEditing, user, setLineEditing,
  setLineId, setLinkEditing, highwayRefresh, showSnackbar, cantonRefresh, setPolylinePoints, isCheckedStartEnd, setIsCheckedStartEnd,
  isCheckedConnection, setIsCheckedConnection ) => {  

  const token = localStorage.getItem('token');
  
    if (!lineId || !lineEditing || !lengthCableEditing) {
      showSnackbar('Необходимые данные для сохранения не найдены!', 'snackbarOk');
      return;
    }
  
    if(markerEditing==CONST_HIGHWAY){
      const coordinatesArray = lineEditing.map(coord => {
        return {
          Latitude: coord.Latitude,
          Longitude: coord.Longitude,
          City: coord.City,
          LengthSegment: coord.LengthSegment
        };
      });
    
      try {
        const response = await axios.patch(POST_EDITING_CABLE_OPTIC_HIGHWAY_API_URL, {
          HighwayId: lineId,
          Coordinates: coordinatesArray,
          AuthorId: user,
          LengthCable: lengthCableEditing,
          IsCheckedConnection: isCheckedConnection                    
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

         const newLineId = response.data;
  
        setLineEditing([]);
        setLineId();
        setPolylinePoints([]);
        highwayRefresh(newLineId);
        setLinkEditing(false);
        setIsCheckedStartEnd(false);
        setIsCheckedConnection(false);
  
       // showSnackbar('Кабель изменен!', 'snackbarOk');
      } catch (error) {
        showSnackbar('Ошибка при сохранении линии!', 'snackbarOk')
      }
    }else if(markerEditing==CONST_CANTON){

      

      let city = 'null';
      let canton = 'null';
      let area = 0;
      let flag = '';
      
      const coordinatesArray = lineEditing.map(coord => {
        if (coord.FlagTerritory === 'city') {
          flag = 'city';
          city = coord.PolygonInfo;
        } else if (coord.FlagTerritory === 'canton') {
          flag = 'canton';
          canton = coord.PolygonInfo;
        } else if (coord.FlagTerritory === 'area') {
          flag = 'area';
          area = coord.PolygonInfo;
        }
      
        const result = {
          Latitude: coord.Latitude,
          Longitude: coord.Longitude,
          City: city,
          Canton: canton,
          Area: area,
          Flag: flag,
          LengthSegment: coord.LengthSegment,
          ConnectionEntrance: coord.ConnectionEntrance,
          ConnectionHid: coord.ConnectionHid,
        };
    
         city = 'null';
         canton = 'null';
         area = 0;
         flag = '';
       
        return result;
      }).filter(coord => coord !== null);
      
      try {
        const response = await axios.patch(POST_EDITING_CABLE_OPTIC_CANTON_API_URL, {
          HighwayId: lineId,
          Coordinates: coordinatesArray,
          AuthorId: user,
          LengthCable: lengthCableEditing,
          IsCheckedStartEnd: isCheckedStartEnd,
          IsCheckedConnection: isCheckedConnection                   
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

         const newLineId = response.data;
  
        setLineEditing([]);
        setLineId();
        setPolylinePoints([]);
        cantonRefresh(newLineId);
        setLinkEditing(false);
        setIsCheckedStartEnd(false);
        setIsCheckedConnection(false);
       // showSnackbar('Кабель изменен!', 'snackbarOk');
      } catch (error) {
        showSnackbar('Ошибка при сохранении линии!', 'snackbarOk')
      }
}
}

// запись таблицу WellCanton
export const WriteWellCanton = async (event, coordinatesManhole, commentTextAreaRefManhole, selectCityManhole, manholeMarker, 
  showSnackbar, setCoordinatesManhole, setCommentManhole,handleClickCantonEdit,setSelectCityManholeIsСhange, selectedOwnerWell,setSelectedOwnerWell, user) => {  
    
    event.preventDefault();
    const token = localStorage.getItem('token');

    const comment = commentTextAreaRefManhole.current.value;
        if (coordinatesManhole.length === 0 || comment.trim() === '' || selectCityManhole == null) {
            showSnackbar('Колодец! Для записи в таблицу необходимо заполнить координаты, комментарий, принадлежность к территории!', 'snackbarWarning');
        return;
        } else if(manholeMarker == true){
            showSnackbar('Колодец! Завершите действие!', 'snackbarWarning');
        } else if(!token){
          showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
        } else{
            try {
            await Promise.all(coordinatesManhole.map(async (coordinate) => {
                await axios.post(POST_WELL_CANTON_API_URL, {
                    Latitude: coordinate.lat,
                    Longitude: coordinate.lng,
                    Description: comment,
                    City: selectCityManhole,
                    Status: 1,
                    Rank: 1,
                    OwnerWellId: selectedOwnerWell,
                    AuthorId: user          
                }, {
                  headers: {
                      'Authorization': `Bearer ${token}`
                  }
              });
            }));
                
            setCoordinatesManhole([]);
            setCommentManhole("");   
            setSelectCityManholeIsСhange(null);    
            setSelectedOwnerWell(null);
            handleClickCantonEdit();
            showSnackbar('Колодец! Данные сохранены успешно', 'snackbarOk');

            } catch (error) {
                console.error("Ошибка при сохранении данных:", error);
            } 
        }
}

//запись PillarCanton
export const WritePillarCanton = async (event, coordinatesPillar, commentTextAreaRefPillar, selectCantonPillar,
    selectedRegionPillar, selectedAreaPillar, pillarMarker, showSnackbar, setCoordinatesPillar, setCommentPillar,
    setSelectCantonPillarIsСhange, setSelectedRegionPillar,setSelectedAreaPillar,handleClickCantonEdit) => {  

        event.preventDefault();
        const token = localStorage.getItem('token');
        const comment = commentTextAreaRefPillar.current.value;

          if (coordinatesPillar.length === 0 || comment.trim() === '' || selectedRegionPillar == null || selectedAreaPillar == null) {
              showSnackbar('Опора! Для записи в таблицу необходимо заполнить координаты, комментарий, принадлежность к территории!', 'snackbarWarning');
            return;
          } else if(pillarMarker == true){
              showSnackbar('Опора! Завершите действие!', 'snackbarWarning');
          } else if(!token){
              showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
          } else{
      
            try {
              await Promise.all(coordinatesPillar.map(async (coordinate) => {
                await axios.post(POST_PILLAR_CANTON_API_URL, {
                  Latitude: coordinate.lat,
                  Longitude: coordinate.lng,
                  Description: comment,
                  City: "kyiv",
                  Canton: selectCantonPillar,
                  Region: selectedRegionPillar,
                  Area: selectedAreaPillar,
                  CreateDate: new Date().toISOString(),
                  ChangeDate: new Date().toISOString(),
                  Status: 1,
                  RankCableId: 1,
                  OwnerPillarId: 2,
                  AuthorId: "User",            
                }, {
                  headers: {
                      'Authorization': `Bearer ${token}`
                  }
              });
              }));
                  
              setCoordinatesPillar([]);
              setCommentPillar(""); 
              setSelectCantonPillarIsСhange(null);   
              setSelectedRegionPillar(null);
              setSelectedAreaPillar(null);
              handleClickCantonEdit();
              showSnackbar('Опора! Данные сохранены успешно', 'snackbarOk');
      
            } catch (error) {
                console.error("Ошибка при сохранении данных:", error);
            } 
        }
}

//запись CouplingCanton
export const WriteCouplingCanton = async (event, coordinatesCoupling, selectedCoupling, commentTextAreaRefCoupling, selectCantonCoupling,
    selectedRegionCoupling,selectedAreaCoupling, couplingMarker, showSnackbar, setCoordinatesCoupling, setCommentCoupling,
    setSelectCantonCouplingIsСhange,setSelectedRegionCoupling, setSelectedAreaCoupling, handleClickCantonEdit,setSelectedCoupling,
    selectedRankCouling, setSelectedRankCoupling, user) => {
   
    event.preventDefault();

    const token = localStorage.getItem('token');
    const comment = commentTextAreaRefCoupling.current.value;
  
      if (coordinatesCoupling.length === 0 || comment.trim() === '' || selectedRegionCoupling === null || selectedAreaCoupling === null || selectedRankCouling == null) {
          showSnackbar('Муфта! Для записи в таблицу необходимо заполнить координаты, комментарий, принадлежность к территории!', 'snackbarWarning');
        return;
      } else if(couplingMarker == true){
          showSnackbar('Муфта! Завершите действие!', 'snackbarWarning');
      } else if(!token){
        showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
      }else{
        try {
          await Promise.all(coordinatesCoupling.map(async (coordinate) => {
            await axios.post(POST_COUPLING_CANTON_API_URL, {           
                CouplingId: selectedCoupling,
                Latitude: coordinate.lat,
                Longitude: coordinate.lng,
                Description: comment,
                Canton: selectCantonCoupling,
                Region: selectedRegionCoupling,
                Area: selectedAreaCoupling,
                RankComponentId: selectedRankCouling,
                Status: 1,
                AuthorId: user                 
            }, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
          }));
              
          setCoordinatesCoupling([]);
          setCommentCoupling("");
          setSelectCantonCouplingIsСhange(null);
          setSelectedRegionCoupling(null);
          setSelectedAreaCoupling(null);
          setSelectedCoupling(null);
          setSelectedRankCoupling(null);
          handleClickCantonEdit();
          showSnackbar('Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
            console.error("Ошибка при сохранении данных:", error);
        } 
      }
}

// запись таблицу FobCanton
export const WriteFobCanton = async (event, coordinatesFob, selectedFob, commentTextAreaRefFob, selectCantonFob,
    selectedRegionFob, selectedAreaFob,fobMarker, showSnackbar, setCoordinatesFob, setCommentFob,
    setSelectCantonFobIsСhange,setSelectedRegionFob,setSelectedAreaFob,handleClickCantonEdit,setSelectedFob, selectedRankFob, setSelectedRankFob, user) => {
    
      event.preventDefault();

      const token = localStorage.getItem('token');
      const comment = commentTextAreaRefFob.current.value;

      if (coordinatesFob.length === 0 || comment.trim() === '' || selectedRegionFob == null || selectedAreaFob == null || selectedFob === null || selectedRankFob == null) {
          showSnackbar('Фоб! Для записи в таблицу необходимо заполнить координаты, комментарий, принадлежность к территории!', 'snackbarWarning');
        return;
      } else if(fobMarker == true){
          showSnackbar('Фоб! Завершите действие!', 'snackbarWarning');
      } else if(!token){
          showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
      } else{
        try {
          await Promise.all(coordinatesFob.map(async (coordinate) => {
            await axios.post(POST_FOB_CANTON_API_URL, {
              FobId: selectedFob,
              Latitude: coordinate.lat,
              Longitude: coordinate.lng,
              Description: comment,
              Canton: selectCantonFob,
              Region: selectedRegionFob,
              Area: selectedAreaFob,
              Status: 1,
              RankComponentId: selectedRankFob,
              AuthorId: user                                     
            }, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
          }));
              
          setCoordinatesFob([]);
          setCommentFob("");
          setSelectCantonFobIsСhange(null);
          setSelectedRegionFob(null);
          setSelectedAreaFob(null);
          setSelectedFob(null);
          setSelectedRankFob(null);
          handleClickCantonEdit();
          showSnackbar('Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
            console.error("Ошибка при сохранении данных:", error);
        } 
      }
}

// запись Problem Cable location
export const WriteProblemCableLocation = async (markerProblemLineCoordinates, lineId, selectedProblemType, textAreaValue,  user, showSnackbar,
  setLinkEditing, setLinkEditingProblem, setSelectedProblemType, setTextAreaValue, setMarkerProblemLineCoordinates, cablaRefresh) => {

    const token = localStorage.getItem('token');
   
    if (markerProblemLineCoordinates === null || textAreaValue === '' || selectedProblemType == null || lineId == '') {
        showSnackbar('Заполните все поля!', 'snackbarWarning');
      return;
    } else if(!token){
        showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    } else{
     
      try {
      
          await axios.post(POST_PROBLEM_CABLE_LOCATION_API_URL, {
            HighwayLineId: lineId,
            ProblemTypeId: selectedProblemType,
            Description: textAreaValue,
            AuthorId: user,
            Latitude: markerProblemLineCoordinates.lat,
            Longitude: markerProblemLineCoordinates.lng                           
          }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
     
        setLinkEditing(false);
        setLinkEditingProblem(false);  
        setSelectedProblemType(null);
        setTextAreaValue("");
        setMarkerProblemLineCoordinates(null);
        cablaRefresh();
      } catch (error) {
          console.error("Ошибка при сохранении данных:", error);
      } 
    }
}
